/**
 *
 * @param focusableElements query selector to define which elements can be cycled with arrow keys.
 * @returns
 */
export const handleKeyDownOnSelector = (focusableElements: string) => (e: KeyboardEvent) => {
  if (document.activeElement && (e.keyCode === 38 || e.keyCode === 40)) {
    const focusable = Array.prototype.filter.call(
      document.querySelectorAll(focusableElements),
      (element) => element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement,
    ); // check for visibility while always include the current activeElement
    let index = focusable.indexOf(document.activeElement);

    if (e.keyCode === 38) {
      e.preventDefault();
      if (index <= 0) index = focusable.length; //  Wrap around
      const nextElement = focusable[index - 1] || focusable[0];
      nextElement.focus();
    }
    if (e.keyCode === 40) {
      e.preventDefault();
      if (index >= focusable.length) index = 0; //  Wrap around
      const nextElement = focusable[index + 1] || focusable[0];
      nextElement.focus();
    }
  }
};
